import { Config } from "../utils";
import ApiController from "./api";
import { Endpoints } from "./types";

export const endpoints: Endpoints = {
	getCart: {
		method: "GET",
		url: "/cart",
	},
	removeCartItem: {
		method: "DELETE",
		url: "/cart/delete",
	},
	updateCartItem: {
		method: "POST",
		url: "/cart/update",
	},
	addProductToCart: {
		method: "POST",
		url: "/cart/add",
		data: {
		quantity: 1,
		},
	}
};

export class WooptimaAPI extends ApiController {
	getCart = async () =>
		this.request({
		endpoint: endpoints.getCart,
		args: {
			params: Config.REACT_APP_ENV === 'staging' ? {
			include: ['theme', 'config', 'translations'].join(',')
			} : {
			include: ['config'].join(',')
			},
		}
		});
	updateCartItem = async (cartItemID: string, data: any) =>
		this.request({
			endpoint: endpoints.updateCartItem,
			query: cartItemID,
			args: {
				data,
			},
		});
	removeCartItem = async (cartItemID: string) =>
		this.request({
			endpoint: endpoints.removeCartItem,
			query: cartItemID
		});
	addProductToCart = async (productID: number, data: any) =>
		this.request({
			endpoint: endpoints.addProductToCart,
			query: productID,
			args: {
				data: {
				quantity: 1,
				...data
				},
			},
		});
};
